import React, { useEffect} from "react";
import {MasterLayoutProvider} from "../../components/layouts/auth/Master";
import {Link} from "react-router-dom";

function Home() {

    useEffect(() => {
        document.querySelector('title').textContent = "Unauthorization - IComPro";
    }, []);


    return (
        <MasterLayoutProvider>
            <section className="bg-transparent flex-1 justify-center items-center"
                     style={{alignContent: 'center', height:'100vh'}}>
                <div className="py-8 px-4 mx-auto max-w-screen-xl lg:py-16 lg:px-6">
                    <div className="mx-auto text-center">
                        <h1 className="mb-4 text-7xl tracking-tight font-extrabold lg:text-9xl text-primary-600">Unauthorization</h1>
                        <p className="mb-4 text-3xl tracking-tight font-bold text-gray-900 md:text-4xl">Oups ! </p>
                        <p className="mb-4 text-lg font-light text-gray-500">Désolé, vous n'avez pas le droit d'accéder à cette application.</p>
                        <Link to="https://jarstechnologies.com" target="_blank"
                              className="inline-flex text-blue-600 bg-primary-600 hover:bg-primary-800 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center my-4">
                           Visiter notre support
                        </Link>
                    </div>
                </div>
            </section>
        </MasterLayoutProvider>
    );
}

export default Home;
